var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartphone15X(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "20px",
    viewBox: "0 0 14 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E5BCA62B-68DD-4E17-8A30-474C098F13AA@1,5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.5,1.66666667 C2.03976271,1.66666667 1.66666667,2.03976271 1.66666667,2.5 L1.66666667,15.8333333 C1.66666667,16.2935706 2.03976271,16.6666667 2.5,16.6666667 L10.8333333,16.6666667 C11.2935706,16.6666667 11.6666667,16.2935706 11.6666667,15.8333333 L11.6666667,2.5 C11.6666667,2.03976271 11.2935706,1.66666667 10.8333333,1.66666667 C10.0700519,1.66666667 9.52143951,1.66666667 9.18749604,1.66666667 C8.68658083,1.66666667 9.18749604,3.3447531 8.33879396,3.3447531 C7.49009188,3.3447531 5.81953661,3.3447531 5.01140939,3.3447531 C4.20328218,3.3447531 4.7710429,1.66666667 4.20328218,1.66666667 C3.82477503,1.66666667 3.2570143,1.66666667 2.5,1.66666667 Z M2.5,3.55271368e-15 L10.8333333,3.55271368e-15 C12.2140452,3.55271368e-15 13.3333333,1.11928813 13.3333333,2.5 L13.3333333,15.8333333 C13.3333333,17.2140452 12.2140452,18.3333333 10.8333333,18.3333333 L2.5,18.3333333 C1.11928813,18.3333333 0,17.2140452 0,15.8333333 L0,2.5 C0,1.11928813 1.11928813,3.55271368e-15 2.5,3.55271368e-15 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Inexplor\\xE9",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01_Profil",
    transform: "translate(-1278.000000, -1011.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    transform: "translate(282.000000, 339.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(64.000000, 596.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Composants-/-Mobile&Web-/-Input-Copy-8",
    transform: "translate(491.499283, 45.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icones-/-Calendrier",
    transform: "translate(440.834051, 31.833333)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle-path",
    fill: "#332E45",
    xlinkHref: "#path-1"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphone15X);
export default __webpack_public_path__ + "static/media/smartphone@1,5x.3c20ced9a834ae81ab605e6fee21dafa.svg";
export { ForwardRef as ReactComponent };